import 'ui-core/widgets/table-of-content/js/table-of-content';

(function () {
    const tocJs = UX.tocJs;
    const tocTranslation = document.querySelector('.toc-js__translation');
    const seeMoreText = (tocTranslation && tocTranslation.dataset.seeMoreText) || 'See all authors';
    const seeLessText = (tocTranslation && tocTranslation.dataset.seeLessText) || 'See fewer authors';
    tocJs.init = () => {
        const $toSection = $('.to-section');
        if ($toSection.length) {
            $toSection.each(function () {
                const $this = $(this),
                    section = $this.text(),
                    id = $(this).attr('id');
                $(
                    '<li role="menuitem"><a class="w-slide__hide" href="#' +
                        id +
                        '"><span>' +
                        section +
                        '</span></a></li>'
                ).appendTo('.sections__drop');
            });
        } else {
            $('.toc-go-section, .toc__section').remove();
        }
        tocJs.$loa = $(
            '.issue-item .loa, .search__item .meta__authors, .search__item .loa, .search-item .meta__authors, .search-item .loa'
        );
        tocJs.control();
    };
    tocJs.truncate = () => {
        try {
            tocJs.$loa.not("[data-truncate='none']").truncate({
                lines: 2,
                type: 'list',
                seeMoreLink: true,
                seeMoreText: seeMoreText,
                seeLessText: seeLessText,
            });
        } catch (err) {
            console.error(err);
        }
    };
    UX.tocJs = tocJs;
})();
